export const STATUS_MONITORING = {
  APPROVAL_MODAL_TITLE: { key: 'APPROVAL_MODAL_TITLE', value: 'Approval Dashboard' },
  APPROVAL_MODAL_TITLE: { key: 'APPROVAL_MODAL_TITLE', value: 'APPROVE FOR PRINTING' },
  PRINTING_MODAL_TITLE: { key: 'PRINTING_MODAL_TITLE', value: 'PRINTING DASHBOARD' },
  REJECT_BATCH_BUTTON: { key: 'REJECT_BATCH_BUTTON', value: 'REJECT BATCH' },
  JOB_PROCESSING_CENTER_TITLE: {
    key: 'JOB_PROCESSING_CENTER_TITLE',
    value: 'JOB PROCESSING CENTER',
  },
  JOB_QUEUE_MODAL_TITLE: {
    key: 'JOB_QUEUE_MODAL_TITLE',
    value: 'JOB QUEUE',
  },
  PRINTING_QUEUE_MODAL_TITLE: {
    key:'PRINTING_QUEUE_MODAL_TITLE',
    value: 'Printing Engine'
  },
  PRINTING_CENTER_MODAL_TITLE: {
    key:'PRINTING_CENTER_MODAL_TITLE',
    value: 'Printing Center'
  },
  CONTROL_CENTER_MODAL_TITLE: {
    key:'CONTROL_CENTER_MODAL_TITLE',
    value: 'Control Center'
  },
  STATUS_MONITORING_TITLE: {
    key: 'STATUS_MONITORING_TITLE',
    value: 'Monitor Status of Transactions',
  },
  DATE_FILTER_LABEL: { key: 'DATE_FILTER_LABEL', value: 'Transaction Date Range' },
  STATUS_FILTER_LABEL: { key: 'STATUS_FILTER_LABEL', value: 'Select a Status' },
  TEAM_FILTER_LABEL: { key: 'TEAM_FILTER_LABEL', value: 'Select a Team' },
  INITIATION_FILTER_LABEL: { key: 'INITIATION_FILTER_LABEL', value: 'Select Initiation From' },
  INITIATED_BY_LABEL: { key: 'INITIATED_BY_LABEL', value: 'Select Initiated By' },
  JOB_NAME_FILTER_LABEL: { key: 'JOB_NAME_FILTER_LABEL', value: 'Search Job Name' },
  APPROVAL_REQUIRED_LABEL: { key: 'APPROVAL_REQUIRED_LABEL', value: 'Approval required' },
  RECONCILIATION_COMPLETE_LABEL: {
    key: 'RECONCILIATION_COMPLETE_LABEL',
    value: 'Reconciliation Complete',
  },

  ALL_OPTION: { key: 'ALL_OPTION', value: 'All' },
  APPLICATION_OPTION: { key: 'APPLICATION_OPTION', value: 'Application' },

  RECEIVED_STATUS: { key: 'RECEIVED_STATUS', value: 'Received' },
  QUEUED_STATUS: { key: 'QUEUED_STATUS', value: 'Queued' },
  PROCESSING_STATUS: { key: 'PROCESSING_STATUS', value: 'Processing' },
  GENERATED_STATUS: { key: 'GENERATED_STATUS', value: 'Generated' },
  DOWNLOAD_COMPLETE_STATUS: { key: 'DOWNLOAD_COMPLETE_STATUS', value: 'Push to server / Download complete' },
  GET_TOKEN_FAILED: { key: 'GET_TOKEN_FAILED', value:'Ooops! something went wrong'},
  IN_PROGRESS: {key: 'IN_PROGRESS', value: 'In progress'},
  YET_TO_START: {key: 'YET_TO_START', value: 'Yet to start'},
  PROCESSING_COMPLETE: {key: 'PROCESSING_COMPLETE', value: 'processing completed'},
  PRINTING_COMPLETE: {key: 'PRINTING_COMPLETE', value: 'Printing completed'},
  SUCCESS: {key: 'SUCCESS', value: 'Success'},
  SENT: {key: 'SENT', value: 'Sent'},
  BOUNCED: {key: 'BOUNCED', value: 'Bounced'},
  DELIVERED: {key: 'DELIVERED', value: 'Delivered'},
  OPENED: {key: 'OPENED', value: 'Opened'},
  CLICKED: {key: 'CLICKED', value: 'Clicked'},
  FAILURE: {key: 'FAILURE', value: 'Failure'},
  WAITING_FOR_APPROVAL_LEVEL_1: {key: 'WAITING_FOR_APPROVAL_LEVEL_1', value: 'Waiting for approval - Level 1'},
  WAITING_FOR_APPROVAL_LEVEL_2: {key: 'WAITING_FOR_APPROVAL_LEVEL_2', value: 'Waiting for approval - Level 2'},
  WAITING_FOR_APPROVAL_LEVEL_3: {key: 'WAITING_FOR_APPROVAL_LEVEL_3', value: 'Waiting for approval - Level 3'},
  WAITING_FOR_APPROVAL_LEVEL_4: {key: 'WAITING_FOR_APPROVAL_LEVEL_4', value: 'Waiting for approval - Level 4'},
  APPROVED_BY_LEVEL_1: {key: 'APPROVED_BY_LEVEL_1', value: 'Approved by - Level 1'},
  APPROVED_BY_LEVEL_2: {key: 'APPROVED_BY_LEVEL_2', value: 'Approved by - Level 2'},
  APPROVED_BY_LEVEL_3: {key: 'APPROVED_BY_LEVEL_3', value: 'Approved by - Level 3'},
  APPROVED_BY_LEVEL_4: {key: 'APPROVED_BY_LEVEL_4', value: 'Approved by - Level 4'},
  REJECT_BY_LEVEL_1: {key: 'REJECT_BY_LEVEL_1', value: 'Rejected by - Level 1'},
  REJECT_BY_LEVEL_2: {key: 'REJECT_BY_LEVEL_2', value: 'Rejected by - Level 2'},
  REJECT_BY_LEVEL_3: {key: 'REJECT_BY_LEVEL_3', value: 'Rejected by - Level 3'},
  REJECT_BY_LEVEL_4: {key: 'REJECT_BY_LEVEL_4', value: 'Rejected by - Level 4'},
  CHANNEL_DOCUMENT: {key: 'CHANNEL_DOCUMENT', value: 'Documents' },
  CHANNEL_EMAIL: {key: 'CHANNEL_EMAIL', value: 'Email' },
  CHANNEL_MESSAGES: {key: 'CHANNEL_MESSAGES', value: 'Messages'},
  CHART_PRINT_LABEL: {key: 'CHART_PRINT_LABEL', value: 'Documents'},
  CHART_MESSAGES_LABEL: {key: 'CHART_MESSAGES_LABEL', value: 'Messages'},
  CHART_SMS_LABEL: {key: 'CHART_SMS_LABEL', value: 'SMS'},
  CHART_EMAIL_LABEL: {key: 'CHART_EMAIL_LABEL', value: 'Email'},
  CHART_VOICE_LABEL: {key: 'CHART_VOICE_LABEL', value: 'Voice Message'},
  CHART_WHATSAPP_LABEL: {key: 'CHART_WHATSAPP_LABEL', value: 'WhatsApp'},
  NO_APPROVER_FOUND_FILTER: { key: 'NO_APPROVER_FOUND_FILTER', value: 'No approver found' },
  READY_TO_PRINT_FILTER: { key: 'READY_TO_PRINT_FILTER', value: 'Ready to print' },
  PRINT_INITIATED_FILTER: { key: 'PRINT_INITIATED_FILTER', value: 'Print initiated' },
  DRAFT_UPLOAD_FILTER: { key: 'DRAFT_UPLOAD_FILTER', value: 'Draft upload' },
  LIVE_UPLOAD_FILTER: { key: 'LIVE_UPLOAD_FILTER', value: 'Live upload' },
  SANDBOX_API_FILTER: { key: 'SANDBOX_API_FILTER', value: 'Sandbox API' },
  LIVE_API_FILTER: { key: 'LIVE_API_FILTER', value: 'API' },
  NO_DATA_TEXT: { key: 'NO_DATA_TEXT', value: 'No Data' },
  NO_RECORDS_FOUND: { key: 'NO_RECORDS_FOUND', value: 'No Records To Show' },
  EXCLUDE_DOCUMENTS_FOR_PRINTING: {key: 'EXCLUDE_DOCUMENTS_FOR_PRINTING', value: 'Exclude documents for printing'},
  YET_TO_PRINT: {key: 'YET_TO_PRINT', value: 'Yet to print'},
  PRINT_IN_QUEUE: {key: 'PRINT_IN_QUEUE', value: 'Print in queue'},
  PRINT_COMPLETED: {key: 'PRINT_COMPLETED', value: 'Print completed'},
};

export const APPROVAL_DASHBOARD_MODAL = {
  APPROVE_BATCH_BUTTON: {
    key: 'APPROVE_BATCH_BUTTON',
    value: 'APPROVE JOB',
  },
  REJECT_BATCH_BUTTON: { key: 'REJECT_BATCH_BUTTON', value: 'REJECT JOB' },
  SEND_FOR_PRINTNG_BUTTON: { key: 'SEND_FOR_PRINTNG_BUTTON', value: 'SEND FOR PRINTING' },
  APPROVED_SUCCESS_MESSAGE: { key: 'APPROVED_SUCCESS_MESSAGE', value: 'Approved' },
  REJECTED_SUCCESS_MESSAGE: { key: 'REJECTED_SUCCESS_MESSAGE', value: 'Rejected' },
  SYNC_STATS: {key: 'SYNC_STATS', value: 'Sync latest stats'},
  PLEASE_WAIT_TEXT: { key: 'PLEASE_WAIT_TEXT', value: 'please wait...' },
  PRINT_INITIATED_SUCCESS_MESSAGE: { key: 'PRINT_INITIATED_SUCCESS_MESSAGE', value: 'Print initiated successfully!' },
  META_SEARCH_EXECUTION_FAILED_ERROR: { key: 'META_SEARCH_EXECUTION_FAILED_ERROR', value: 'Failed during the execution of the metadata search.' },
  RECORDS_NOT_AVAILABLE_ERROR: { key: 'RECORDS_NOT_AVAILABLE_ERROR', value: 'The records are unavailable for printing.' },
  PRINT_NOT_CONFIGURED_ERROR: { key: 'PRINT_NOT_CONFIGURED_ERROR', value: 'Printer configuration is unavailable.' },
  PRINT_CONFIGURATION_INVALID_ERROR: { key: 'PRINT_CONFIGURATION_INVALID_ERROR', value: 'The printer configuration is invalid.' },
  UNABLE_TO_SEND_FOR_PRINTING_ERROR: { key: 'UNABLE_TO_SEND_FOR_PRINTING_ERROR', value: 'Unable to send transactions for printing.' },
};

export const SEARCHABLE_TABLE = {
  FAILURE_RECORDS: {key: 'FAILURE_RECORDS', value: 'Failure Records'},
  REMOVED_RECORDS: {key: 'REMOVED_RECORDS', value: 'Removed Records'},
  SEARCH_METADATA_PLACEHOLDER: { key: 'SEARCH_METADATA_PLACEHOLDER', value: 'Search by Metadata' },
  SEARCH_EXACT_METADATA_PLACEHOLDER: { key: 'SEARCH_EXACT_METADATA_PLACEHOLDER', value: 'Search Metadata using an exact phrase' },
  CLEAR_FILTER_BUTTON: { key: 'CLEAR_FILTER_BUTTON', value: 'Clear Filter' },
  PAYLOAD_TABLE_HEADER: { key: 'PAYLOAD_TABLE_HEADER', value: 'Payload' },
  GENERATED_PDF_TABLE_HEADER: { key: 'GENERATED_PDF_TABLE_HEADER', value: 'Generated PDF' },
  SELECTED_DOCUMENT_LABEL: {
    key: 'SELECTED_DOCUMENT_LABEL',
    value: 'No of Documents selected to print',
  },
  COPY_PAYLOAD_BUTTON: { key: 'COPY_PAYLOAD_BUTTON', value: 'Copy Payload' },
  PAYLOAD_MODAL_TITLE: { key: 'PAYLOAD_MODAL_TITLE', value: 'Payload' },
  PAYLOAD_COPIED_SUCCESS_MESSAGE: { key: 'PAYLOAD_COPIED_SUCCESS_MESSAGE', value: 'Payload copied to clipboard!' },
  FAILED_TO_COPY_PAYLOAD: { key: 'FAILED_TO_COPY_PAYLOAD', value: 'Failed to copy Payload!' },
  CHANNEL: { key: 'CHANNEL', value: 'Channel' },
  LANGUAGE: { key: 'LANGUAGE', value: 'Language' },
  STATUS: { key: 'STATUS', value: 'Status' },
  PRINT_STATUS: { key: 'PRINT_STATUS', value: 'Print status' },
  UNIQ_NAME: { key: 'UNIQ_NAME', value: 'Uniq Name' },
  UNIQ_ID: { key: 'UNIQ_ID', value: 'Uniq Id' },
  PAYLOAD: { key: 'PAYLOAD', value: 'Payload' },
  NUMBER_OF_PAGES:{key: 'NUMBER_OF_PAGES' , value: 'Number of pages' },
  TIME_OF_CREATION:{key: 'TIME_OF_CREATION' , value: 'Time of creation' },
  FAILURE_REASON:{key: 'FAILURE_REASON' , value: 'Reason for failure' },
  GENERATE_PDF:{key: 'GENERATE_PDF' , value: 'Generated PDF' },
  GENERATE_PDF_FAILED:{key: 'GENERATE_PDF_FAILED' , value: 'Failed to Generated PDF' },
  NO_RECORDS_FOUND: { key: 'NO_RECORDS_FOUND', value: 'No Records To Show.' },
  NO_DATA_FOR_SEARCH: { key: 'NO_DATA_FOR_SEARCH', value: 'No data available for your search.'},
  ALL_SENT_FOR_PRINTING: { key:'ALL_SENT_FOR_PRINTING', value: 'All documents are sent for printing. Please check printing center for status..'}
};

export const BATCH_REJECTION_MODAL = {
  NOTIFY_USER_LABEL: {
    key: 'NOFIFY_USER_LABEL',
    value: 'Notify users',
  },
  REJECTION_ACTION_BUTTON: {
    key: 'REJECTION_ACTION_BUTTON',
    value: 'CONFIRM REJECTION',
  },
  ENTER_MAIL_ADDRESS_PLACEHOLDER: {
    key: 'ENTER_MAIL_ADDRESS_PLACEHOLDER',
    value: 'Please Enter to add mail address',
  },
  REJECTION_BATCH_PLACEHOLDER: {
    key: 'REJECTION_BATCH_PLACEHOLDER',
    value: 'Enter reason for rejecting this batch',
  },
  JOB_REJECTION_PLACEHOLDER: {
    key: 'JOB_REJECTION_PLACEHOLDER',
    value: 'Provide detailed comments for this rejection.'
  },
  BATCH_REJECTION_MODAL_HEADER: {
    key: 'BATCH_REJECTION_MODAL_HEADER',
    value: 'BATCH REJECTION',
  },
  EMAIL_ID_EXISTS_ERROR: {
    key: 'EMAIL_ID_EXISTS_ERROR',
    value: 'Email ID already exists!'
  },
  INVALID_EMAIL_ID_ERROR: {
    key: 'INVALID_EMAIL_ID_ERROR',
    value: 'Please enter a valid email address.'
  },
  ENTER_EMAIL_ADDRESS: {
    key: 'ENTER_EMAIL_ADDRESS',
    value: 'Please enter an email address!'
  },
  REJECT_REASON_REQUIRED_ERROR: {
    key: 'REJECT_REASON_REQUIRED_ERROR',
    value: 'Please fill out this field!'
  },
};

export const STEPS = {
  LEVEL_LABEL: { key: 'LEVEL_LABEL', value: 'Level {{level}}' },
};

export const ACTION_CARD = {
  DOCUMENT_LABEL: { key: 'DOCUMENT_LABEL', value: 'Document' },
  EMAIL_LABEL: { key: 'EMAIL_LABEL', value: 'Email' },
  MESSAGES_LABEL: { key: 'MESSAGES_LABEL', value: 'Messages' },
  PROCESS_COMPLETE_LABEL: { key: 'PROCESS_COMPLETE_LABEL', value: 'Batch Processing Complete' },
  APPROVAL_COMPLETE_LABEL: {
    key: 'APPROVAL_COMPLETE_LABEL',
    value: 'Level {{level}} Approval Complete',
  },
  APPROVAL_REJECTED_LABEL: {
    key: 'APPROVAL_REJECTED_LABEL',
    value: 'Level {{level}} Approval Rejected',
  },
  JOB_QUEUE_TITLE: { key: 'JOB_QUEUE_TITLE', value: 'Job Queue' },
  PROCESSING_CENTER_TITLE: { key: 'PROCESSING_CENTER_TITLE', value: 'Job Processing Center' },
  APPROVAL_ENGINE_TITLE: { key: 'APPROVAL_ENGINE_TITLE', value: 'Approval Engine' },
  PRINTING_ENGINE_TITLE: { key: 'PRINTING_ENGINE_TITLE', value: 'Printing Engine' },
  PRINTING_CENTER_TITLE: { key: 'PRINTING_CENTER_TITLE', value: 'Printing Center' },
  CONTROL_CENTER_TITLE: { key: 'CONTROL_CENTER_TITLE', value: 'Control Center' },

  DOCUMENT_QUEUED_TEXT: { key: 'DOCUMENT_QUEUED_TEXT', value: 'documents queued for printing' },
  PRINTING_COMPLETE_TEXT: { key: 'PRINTING_COMPLETE_TEXT', value: 'documents printing complete' },
  SEND_FOR_PRINTNG_BUTTON: { key: 'SEND_FOR_PRINTNG_BUTTON', value: 'Send for printing' },
  REVIEW_AND_APPROVE_BUTTON: { key: 'REVIEW_AND_APPROVE_BUTTON', value: 'Review & Approve' },
  NO_APPROVER_FOUND_INFO: { key: 'NO_APPROVER_FOUND_INFO', value: 'Would you like to still proceed with the approval process?' },
  PROCEED_WITH_APPROVAL_BUTTON: { key: 'PROCEED_WITH_APPROVAL_BUTTON', value: 'Proceed with approval' },
  SKIP_APPROVAL_BUTTON: { key: 'SKIP_APPROVAL_BUTTON', value: 'Skip Approval' },
  NO_APPROVER_FOUND_WARNING: { key: 'NO_APPROVER_FOUND_WARNING', value: 'No approver found' },
  APPROVERS_NOT_AVAILABLE_ERROR: { key: 'APPROVERS_NOT_AVAILABLE_ERROR', value: 'Approvers are not available. Please try again later!' },
  PRINT_SERVICE_IS_NOT_CONFIGURED: { key: 'PRINT_SERVICE_IS_NOT_CONFIGURED', value: "The external print service isn't configured." },
};

export const JOB_QUEUE_MODAL = {
  ORIGIN_DETAILS_TITLE: { key: 'ORIGIN_DETAILS_TITLE', value: 'ORIGIN DETAILS' },
  STATS_TITLE: { key: 'STATS_TITLE', value: 'STATS' },
  RECORD_DETAILS_TITLE: { key: 'RECORD_DETAILS_TITLE', value: 'RECORD DETAILS' },
  EMPTY_PRINT_BATCH: {
    key:'EMPTY_PRINT_BATCH',
    value:'There are no print batches in the queue.'
  },
  BATCH_RECEPTION_START_STATUS: {
    key: 'BATCH_RECEPTION_START_STATUS',
    value: 'Batch Reception Started',
  },
  BATCH_RECEPTION_COMPLETED_STATUS: {
    key: 'BATCH_RECEPTION_COMPLETED_STATUS',
    value: 'Batch Reception Completed',
  },
  RECORD_SEARCH_TITLE: {
    key: 'RECORD_SEARCH_TITLE',
    value: 'RECORD SEARCH',
  },
  RECORD_SEARCH_TITLE: {
    key: 'RECORD_SEARCH_TITLE',
    value: 'RECORD SEARCH',
  },
  PROCESSING_LABEL: {
    key: 'PROCESSING_LABEL',
    value: 'sent for processing',
  },
  INITIATED_BY_LABEL: {
    key: 'INITIATED_BY_LABEL',
    value: 'INITIATED BY',
  },
  INITIATED_FROM_LABEL: {
    key: 'INITIATED_FROM_LABEL',
    value: 'INITIATED FROM',
  },
  INITIATED_ON_LABEL: {
    key: 'INITIATED_ON_LABEL',
    value: 'INITIATED ON',
  },
  RECORDS_LABEL: {
    key: 'RECORDS_LABEL',
    value: 'records',
  },
  BATCH_LABEL: {
    key: 'BATCH_LABEL',
    value: 'Batch',
  },
  TOTAL_DOC_COUNT: {
    key: 'TOTAL_DOC_COUNT',
    value:'Document Count : {{count}}'
  },
  PRINT_BATCH_DETAILS: {
    key: 'PRINT_BATCH_DETAILS',
    value: 'PRINT BATCH DETAILS'
  },
  REMOVED_FILTER_LABEL : {
    key: 'REMOVED_FILTER_LABEL',
    value: 'Removed filters'
  },
  SEARCH_FILTER_LABEL : {
    key: 'SEARCH_FILTER_LABEL',
    value: 'Search filters'
  },
  EMPTY_SEARCH_EXCLUSION: {
    key: 'EMPTY_SEARCH_EXCLUSION',
    value: 'No search or exclusion filters have been applied to this batch.'
  },
  NO_UNKNOWN_MESSAGE: {
    key : 'NO_UNKNOWN_MESSAGE',
    value: 'No unknown records found'
  }
};

export const DOCUMENT_PANEL = {
  LANGUAGES_STATS: {
    key: 'LANGUAGES_STATS',
    value: 'LANGUAGE STATS',
  },
  FAILURE_STATS: {
    key: 'FAILURE_STATS',
    value: 'FAILURE STATS',
  },
  REMOVE_FROM_JOB: {
    key: 'REMOVE_FROM_JOB',
    value: 'REMOVE FROM JOB',
  },
  VIEW_REMOVED_RECORDS: {
    key: 'VIEW_REMOVED_RECORDS',
    value: 'View Removed Records',
  },
  VIEW_FAILURE_RECORDS: {
    key: 'VIEW_FAILURE_RECORDS',
    value: 'View Failure Records',
  },
  SEARCH_REMOVED_DOCUMENTS: {
    key: 'SEARCH_REMOVED_DOCUMENTS',
    value: 'Search for docs to be removed',
  },
  REMOVED_RECORDS_COUNT: {
    key: 'REMOVED_RECORDS_COUNT',
    value: 'records removed',
  },
  SUCCESS_CHART_LABEL: {
    key: 'SUCCESS_CHART_LABEL',
    value: 'Success',
  },
  INPROGRESS_CHART_LABEL: {
    key: 'INPROGRESS_CHART_LABEL',
    value: 'InProgress',
  },
  FAILURE_CHART_LABEL: {
    key: 'FAILURE_CHART_LABEL',
    value: 'Failure',
  },
  TOTAL_CHART_LABEL: {
    key: 'TOTAL_CHART_LABEL',
    value: 'Total',
  },
};

export const SEARCH_SELECT_DROPDOWN = {
  NO_OPTIONS_AVAILABLE: {
    key: 'NO_OPTIONS_AVAILABLE',
    value: 'No options available',
  },
  LOADING_TEXT: {
    key: 'LOADING_TEXT',
    value: 'Loading...',
  },
  LANGUAGE: { key: 'LANGUAGE', value: 'Language' }
};

export const CONTROL_CENTER_MODAL = {
  UNKNOWN_COUNT : {
    key:'UNKNOWN_COUNT',
    value: 'Unknown Count'
  },
  FAILURE_COUNT : {
    key:'FAILURE_COUNT',
    value: 'Failure Count'
  },
  REMOVED_RECORDS_COUNT : {
    key:'REMOVED_RECORDS_COUNT',
    value: 'Removed Records Count'
  },
  UNKNOWN_RECORDS_LABEL : {
    key:'UNKNOWN_RECORDS_LABEL',
    value: 'Unknown Records'
  },
  REQUEST_RECEIVED_COUNT: {
    key : 'REQUEST_RECEIVED_COUNT',
    value: 'Request Received Count'
  },
  PRINTED_COUNT: {
    key:'PRINTED_COUNT',
    value: 'Printed Count'
  },
  PROCESSED_COUNT: {
    key:'PROCESSED_COUNT',
    value: 'Request Processed Count'
  },
}
